import { useRelocationRecord } from "@/app/Relocations/Hooks/useRelocationRecord";
import { WaitlistTable } from "@/app/Waitlists/Components/WaitlistTable";
import { QueryWaitlistsWhereColumn } from "@/gql/graphql";

export function RelocationWaitlistScreen() {
  const record = useRelocationRecord();

  return (
    <div className="space-y-10 py-6">
      <WaitlistTable
        title="Waitlists (Direct Match)"
        id="relocation-waitlists"
        searchable={false}
        queryVariables={{
          relocationId: record.id,
          where: {
            AND: [
              {
                column: QueryWaitlistsWhereColumn.DepartureCityId,
                value: record.departureCity.id,
              },
              {
                column: QueryWaitlistsWhereColumn.DeliveryCityId,
                value: record.deliveryCity.id,
              },
            ],
          },
        }}
      />

      <WaitlistTable
        title="Waitlists (Broad Match)"
        id="relocation-waitlists"
        searchable={false}
        queryVariables={{
          relocationId: record.id,
        }}
      />
    </div>
  );
}
